var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.35 12.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15,21.25c-6.08,0-8.41-5.64-8.5-5.88L6.33,15l.15-.37c.09-.24,2.42-5.88,8.5-5.88,5.57,0,8.36,5.57,8.48,5.81l.21.44-.21.44C23.34,15.68,20.55,21.25,15,21.25ZM8.51,15A7.4,7.4,0,0,0,15,19.25c3.51,0,5.72-3.08,6.43-4.25-.71-1.17-2.92-4.25-6.43-4.25A7.39,7.39,0,0,0,8.51,15Z",
    transform: "translate(-6.33 -8.75)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15,18.21A3.21,3.21,0,1,1,18.19,15,3.21,3.21,0,0,1,15,18.21Zm0-4.42A1.21,1.21,0,1,0,16.19,15,1.21,1.21,0,0,0,15,13.79Z",
    transform: "translate(-6.33 -8.75)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowIcon);
export default __webpack_public_path__ + "static/media/show-icon.cf9ca8064cd8a89eae295be4537dcf98.svg";
export { ForwardRef as ReactComponent };